import { Routes, Route } from 'react-router-dom';
import { PAGE_PATHS } from './constants';
import SetupUserPage from 'pages/SetupUser';
import Login from 'pages/Login';
import Register from 'pages/Register';
import VerifyUser from 'pages/VerifyUser';
import PrintLabel from 'pages/PrintLabel';
import Products from 'pages/Product';
import ProductDraft from 'pages/ProductDraft';
import Inquiry from 'pages/Inquiry';
import JobStageNav from 'components/JobStageNav';
import Job from 'pages/Job';
import SearchReport from 'pages/SearchReport';
import Quote from 'pages/Quote';
import Order from 'pages/Order';
import Clients from 'pages/Clients';
import ClientProfileNav from 'components/ClientProfileNav';
import ClientProfile from 'pages/ClientProfile';

function Routing() {
  return (
    <Routes>
      <Route path={PAGE_PATHS.LOGIN} exact element={<Login />} />
      <Route path={PAGE_PATHS.REGISTER} exact element={<Register />} />
      <Route path={PAGE_PATHS.VERIFY_USER} exact element={<VerifyUser />} />
      <Route path={PAGE_PATHS.SETUP} exact element={<SetupUserPage />} />
      <Route
        path={PAGE_PATHS.RESET_PASSWORD}
        exact
        element={<SetupUserPage />}
      />
      <Route path={PAGE_PATHS.PRINT_LABEL} exact element={<PrintLabel />} />
      <Route path={PAGE_PATHS.JOB} element={<Job />} />
      <Route path={PAGE_PATHS.CLIENTS} element={<Clients />} />
      <Route path={`${PAGE_PATHS.CLIENTS}/:id`} element={<ClientProfileNav />}>
        <Route
          path={`${PAGE_PATHS.CLIENT_PROFILE.PROFILE}`}
          exact
          element={<ClientProfile />}
        />
        <Route
          path={`${PAGE_PATHS.CLIENT_PROFILE.ADDRESS}`}
          exact
          element={<div>is it</div>}
        />
        <Route
          path={`${PAGE_PATHS.CLIENT_PROFILE.BILLING}`}
          exact
          element={<div>going?</div>}
        />
      </Route>
      <Route path={PAGE_PATHS.CREATE_JOB.ROOT} exact element={<JobStageNav />}>
        <Route
          path={`${PAGE_PATHS.CREATE_JOB.INQUIRY}/:ID`}
          exact
          element={<Inquiry />}
        />
        <Route
          path={`${PAGE_PATHS.CREATE_JOB.SEARCH_REPORT}/:ID`}
          exact
          element={<SearchReport />}
        />
        <Route
          path={`${PAGE_PATHS.CREATE_JOB.QUOTE}/:ID`}
          exact
          element={<Quote />}
        />
        <Route
          path={`${PAGE_PATHS.CREATE_JOB.ORDER}/:ID`}
          exact
          element={<Order />}
        />
      </Route>
      <Route path={PAGE_PATHS.PRODUCT} element={<Products />} />
      <Route path={PAGE_PATHS.PRODUCT_DRAFT} exact element={<ProductDraft />} />
    </Routes>
  );
}

export default Routing;
